import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  Box,
  Radio
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {dropdownFetch, formatDate, getMonthYear, request, toast } from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import {
  PHARMACY_PRODUCT_TYPE
} from '../../../../../constants/dropdown';

const POS_HEADER = [
  { header: 'Stock Transfer No.', accessor: 'stock_transfer_no' },
  { header: 'From Location', accessor: 'from_location_name' },
  { header: 'To Location', accessor: 'to_location_name' },

];

const INDENT_TABLE_COLUMNS = [
  { header: 'Indent No.', accessor: 'indent_no' },
  {
    header: 'To Organisation',
    accessor: (row) => row?.warehousestocktransferinfo?.to_org
  },
  {
    header: 'To Location',
    accessor: (row) => row?.to_location?.warehouse_name
  },
  {
    header: 'Tranferred By',
    accessor: (row) => row?.createdBy
  },
  {
    header: 'Date',
    accessor: (row) => formatDate(row?.createdAt)
  }
];

const initialStockTransferAcceptDataObj = {
  data: [],
  loading: false
};
const initialStockTransferDataObj = {
  data: [],
  loading: false
};
export const StockTransferAccept = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [stockTranferDataObj, setStockTransferDataObj] = useState(initialStockTransferDataObj);
  const [stockTranferAcceptDataObj, setStockTransferAcceptDataObj] = useState(initialStockTransferAcceptDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [input, setInput] = useState('');
  const [warehouse, setWareHosue] = useState([]);
  const [posData, setPosData] = useState([]);
  const productRef = useRef();
  const [medicineData, setMedicineData] = useState([]);
  const [productDetails, setProductDetails] = useState([]);
  const [queryInput,setQueryInput] = useState('')
  const user = JSON.parse(localStorage.getItem('user'));

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        stock_transfer_no: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      stock_transfer_date: new Date().toISOString().split('T')[0],
      time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),
      product_type: 'pharmacy product',
      bill: {
        out_sourced: 'No',
        tds_amt: 0,
        disc_amt: 0,
        gst_amt: 0,
        net_amt: 0
      }
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;

  console.log(productDetails,"PRODCUTDETAILS IS HERE !!")
  const formSubmit = async (formValues) => {
    setLoading(true);
    const productData = productDetails?.map((row) => ({
      ...row,
      product: row?.issued_product && row?.requested_product ? row?.issued_product : row?.requested_product,
      quantity : row?.issued_quantity && row?.requested_qty ? row?.issued_quantity : row?.requested_qty,
    }));
    const payload = {
      ...formValues,
      productDetails: productData,
    };
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/retail-sale-update' : '/stock-transfer-voucher-accept-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        ...payload,
        createdBy: user.name,
        updatedBy: editFlag ? user.name : '',
        organisation
      }
    });
    if (response?.success && response.data) {
      toast(`Successfully ${editFlag ? 'edited' : 'created'} Stock Transfer Accepted Successfully`, { variant: 'success' });
      setSelectedRecord(response?.data);
      setCurrentAction();
      setMedicineData([]);
      fetchStockTransferVoucher();
    } else {
      toast(`Failed to ${editFlag ? 'edit' : 'create'} `, { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setStockTransferAcceptDataObj({ loading: true });
    const response = await request('/stock-transfer-voucher-accept-list', { method: 'GET' });
    if (response.success) {
      const filteredData = response.data.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setStockTransferAcceptDataObj({ loading: false, data: filteredData });
      setPosData({ data: response.data });
    } else {
      toast('Failed to load Stock Transfer Accept List', { variant: 'error' });
      setStockTransferAcceptDataObj({ loading: false });
    }
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/retail-sale-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully cancel Retail Sale Pos', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to cancel Retail Sale Pos', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/retail-sale-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Retail Sale Pos', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Retail Sale Pos', { variant: 'error' });
    }
    setLoading(false);
  };

  const getLocationDropdown = useCallback(async () => {
    const data = await dropdownFetch('warehouse');
    if (!selectedRecord) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('location', defaultState?._id);
    }
    setWareHosue(data);
  }, []);

  useEffect(() => {
    getLocationDropdown();
  }, [getLocationDropdown]);

  const handleRowClick = (row) => {
    setProductDetails(row?.productDetails);
    setValue('stock_transfer_no', row?.stock_transfer_no);
    setValue('from_location', row?.from_location?.warehouse_name);
    setValue('to_location', row?.to_location?.warehouse_name);
    setValue('to_location_id',row?.to_location?._id)
    setValue('transferred_by', row?.createdBy);
    setValue('indent_no', row?.indent_no);
    setValue('product_type', row?.warehousestocktransferinfo?.product_type);
  };

  const PRODUCT_TABLE_HEADER = [
    {
      header: 'Product Name',
      accessor: (row) => {
        if (row?.issued_product_name) {
          return row?.issued_product_name;
        }
        if (row?.issued_store_product_name) {
          return row?.issued_store_product_name;
        }
        if (row?.requested_product_name) {
          return row?.requested_product_name;
        }
        if(row?.product_name){
          return row?.product_name
        }
      }
    },
    { header: 'Batch No.', accessor: (row) => row?.batch_no },
    { header: 'Exp Date', accessor: (row) => getMonthYear(row?.exp_date) },
    {
      header: 'Qty',
      accessor: (row) => {
        if (row?.requested_qty && row?.issued_quantity) {
          return row.issued_quantity;
        }
        return row?.requested_qty ?? row?.quantity;
      }
    },    
    { header: 'Cost Price', accessor: (row) => row?.cost_price },
    { header: 'MRP', accessor: (row) => row?.mrp },
    { header: 'Sale Price', accessor: (row) => row?.sale_price }
  ];

  const fetchStockTransferVoucher = async () => {
    setStockTransferDataObj({ loading: true });
    const response = await request('/stock-transfer-voucher-not-approved-list', { method: 'GET' });
    if (response.success) {
      setStockTransferDataObj({ loading: false, data: response?.data });
    } else {
      toast('Failed to load Retail Sale list', { variant: 'error' });
      setStockTransferDataObj({ loading: false });
    }
  };

  useEffect(() => {
    fetchStockTransferVoucher();
  }, []);


  useEffect(()=>{
if(selectedRecord){
  setValue('stock_transfer_no',selectedRecord?.stock_transfer_no)
  setValue('from_location',selectedRecord?.from_location_name)
  setValue('to_location',selectedRecord?.to_location_name)
  setProductDetails(selectedRecord.productDetails)
}
  },[selectedRecord])


  useEffect(()=>{
    handleSearch()
  },[queryInput])

  const handleSearch = async () => {
    const lowercasedInput = queryInput.toUpperCase().trim();
    const limit = 10;
    try {
      const response = await request('/stock-transfer-voucher-accept-list', {
        method: 'GET',
        query: { name: lowercasedInput, limit: limit }
      });
      if (response.success) {
        const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        const filteredData = sortedData.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setStockTransferAcceptDataObj({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching dataaaaa', { variant: 'error' });
        setStockTransferAcceptDataObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setStockTransferAcceptDataObj({ loading: false, data: [] });
    }
  };

  const handleQueryChange=(e)=>{
   setQueryInput(e.target.value)
  }

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                 Stock Transfer Accept
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setProductDetails([]);
                    reset();
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction)}
                  onClick={handleQueryWindow}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={1}>
                <Grid item xs={3.5} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Product Type</Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{
                        flex: 0.8,
                        border: currentAction ? '0.5px solid red' : '',
                        backgroundColor: currentAction ? '#B3E5FC' : ''
                      }}
                      name="product_type"
                      menus={PHARMACY_PRODUCT_TYPE}
                    />
                  </Stack>
                  <Grid item sx={{ display: 'flex', flexDirection: 'column', minHeight: '52rem', marginTop: '1%' }}>
                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
                      <MuiTextField
                        sx={{
                          width: '100%',
                          '& .MuiOutlinedInput-root': {
                            padding: '0',
                            fontSize: '16px',
                            fontWeight: '700'
                          },
                          '& .MuiOutlinedInput-input': {
                            padding: '8px 14px'
                          }
                        }}
                        label="Search Here"
                        variant="outlined"
                        value={input}
                        inputRef={productRef}
                      />
                    </Stack>

                    <Table
                      containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)', minHeight: '50rem' }}
                      data={currentAction === 'new' ? stockTranferDataObj?.data : []}
                      columns={INDENT_TABLE_COLUMNS}
                      size="small"
                      onRowClick={(row) => {
                        handleRowClick(row);
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={8.5} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                  <Stack
                    sx={{ border: '0px solid grey', padding: '5px', borderRadius: '5px' }}
                    spacing={0.5}
                    direction="row"
                  >
                    <Grid
                      item
                      xs={6}
                      sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, boxShadow: '0px 2px 2px #0099ff' }}
                    >
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>
                          Stock Transfer No.
                        </Typography>
                        <TextField
                          disabled
                          sx={{
                            flex: 0.8,
                            border: currentAction ? '0.5px solid red' : '',
                            backgroundColor: currentAction ? '#B3E5FC' : ''
                          }}
                          name="stock_transfer_no"
                          placeholder="Stock Trnasfer No."
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>From Location</Typography>
                        <TextField
                          disabled
                          sx={{
                            flex: 0.8,
                            border: currentAction ? '0.5px solid red' : '',
                            backgroundColor: currentAction ? '#B3E5FC' : ''
                          }}
                          name="from_location"
                          placeholder="From Location"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Product Type</Typography>
                        <TextField disabled sx={{ flex: 0.8 }} name="product_type" placeholder="Product Type" />
                      </Stack>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, boxShadow: '0px 2px 2px #0099ff' }}
                    >
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>
                          Stock Transfer Date
                        </Typography>
                        <TextField disabled sx={{ flex: 0.8 }} name="stock_transfer_date" type="date" />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>To Location</Typography>
                        <TextField disabled sx={{ flex: 0.8 }} name="to_location" placeholder="To Location" />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Transferred By</Typography>
                        <TextField disabled sx={{ flex: 0.8 }} name="transferred_by" placeholder="Transferred By" />
                      </Stack>
                    </Grid>
                  </Stack>
                  <Table
                    containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                    data={productDetails.map((data) => ({ ...data, _id: data?._id })) || []}
                    columns={PRODUCT_TABLE_HEADER}
                    size="small"
                  />
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
          Stock Transfer Accept Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '16px',
                fontWeight: '700'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
              }
            }}
            label="Search By Doc No."
            variant="outlined"
            value={queryInput}
            onChange={handleQueryChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={POS_HEADER}
          data={stockTranferAcceptDataObj?.data|| []}
          loading={posData.loading}
          onRowClick={(row) => {
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
    </>
  );
};
